<template>
  <div class="rules-page pk-account-panel">
    <section class="rules-hero case-hero">
      <button class="back-btn" @click="goCases">返回</button>
      <span>打开箱子</span>
      <h1>打开箱子规则</h1>
      <p>箱子详情展示价格、饰品和掉落列表。</p>
    </section>

    <section class="rules-grid">
      <article v-for="rule in rules" :key="rule.title" class="rule-card">
        <em>{{ rule.num }}</em>
        <strong>{{ rule.title }}</strong>
        <p>{{ rule.text }}</p>
      </article>
    </section>

    <section class="verify-panel">
      <div>
        <span>箱子信息</span>
        <strong>掉落与奖品</strong>
        <p>打开箱子后，饰品会进入背包。</p>
      </div>
      <button @click="$router.push({ path: '/Index' })">返回箱子列表</button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        { num: "01", title: "选择箱子", text: "进入箱子详情页后可以查看箱子价格、掉落列表和打开数量。" },
        { num: "02", title: "打开箱子消耗", text: "点击打开箱子会按箱子价格结算账户可用余额。" },
        { num: "03", title: "动画展示", text: "转动动画结束后显示本次结果。" },
        { num: "04", title: "奖品进入背包", text: "开出的饰品会进入背包页面，用户可以查看价格和状态。" },
        { num: "05", title: "回收与取回", text: "开出的饰品可在背包中回收或申请取回。" },
        { num: "06", title: "掉落说明", text: "箱内掉落会随箱子配置更新。" },
      ],
    };
  },
  methods: {
    goCases() {
      this.$router.push({ path: "/Index" });
    },
  },
};
</script>

<style lang="less" scoped>
.rules-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.rules-hero,
.rules-grid,
.verify-panel {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.rules-hero {
  min-height: 286px;
  padding: 46px 54px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.rules-hero::after {
  content: "";
  width: 780px;
  height: 280px;
  position: absolute;
  right: -170px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.rules-hero span,
.verify-panel span {
  position: relative;
  z-index: 1;
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.rules-hero h1 {
  position: relative;
  z-index: 1;
  margin: 12px 0 14px;
  font-size: 64px;
  line-height: 0.98;
  font-weight: 1000;
}

.rules-hero p {
  position: relative;
  z-index: 1;
  max-width: 760px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.rules-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.rule-card {
  min-height: 182px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 16px 44px rgba(0, 0, 0, 0.22);
}

.rule-card em {
  position: absolute;
  right: 18px;
  top: 10px;
  color: rgba(255, 138, 0, 0.16);
  font-size: 58px;
  font-style: normal;
  font-weight: 1000;
}

.rule-card strong {
  position: relative;
  display: block;
  color: #fff4d8;
  font-size: 22px;
  font-weight: 1000;
}

.rule-card p {
  position: relative;
  margin: 14px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.8;
  font-weight: 800;
}

.verify-panel {
  margin-top: 22px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 18px;
  align-items: center;
  border-radius: 14px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.verify-panel strong {
  display: block;
  margin-top: 8px;
  color: #f7f9ff;
  font-size: 24px;
  font-weight: 1000;
}

.verify-panel p {
  margin: 8px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 800;
}

.verify-panel button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.24);
}

@media screen and (max-width: 980px) {
  .rules-page {
    padding: 20px 12px 64px;
  }

  .rules-hero {
    padding: 72px 24px 34px;
  }

  .rules-hero h1 {
    font-size: 46px;
  }

  .rules-grid,
  .verify-panel {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="less">
.rules-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 22px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(253, 107, 1, 0.08), transparent 360px),
    #191b26 !important;
}

.rules-page.pk-account-panel .rules-hero,
.rules-page.pk-account-panel .rules-grid,
.rules-page.pk-account-panel .verify-panel {
  width: 100% !important;
  max-width: none !important;
}

.rules-page.pk-account-panel .rules-hero {
  min-height: 224px !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 16% 40%, rgba(255, 132, 31, 0.16), transparent 260px),
    #20222f !important;
  border-color: #2b2d3c !important;
  box-shadow: none !important;
}

.rules-page.pk-account-panel .rules-grid {
  gap: 8px !important;
}

.rules-page.pk-account-panel .rule-card,
.rules-page.pk-account-panel .verify-panel {
  border-radius: 8px !important;
  border-color: #2b2d3c !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.rules-page.pk-account-panel .rule-card {
  min-height: 156px !important;
}
</style>

<style lang="less">
.rules-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.rules-page.pk-account-panel .rules-hero,
.rules-page.pk-account-panel .rules-grid,
.rules-page.pk-account-panel .verify-panel {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.rules-page.pk-account-panel .rules-hero {
  min-height: 318px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.rules-page.pk-account-panel .rules-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

.rules-page.pk-account-panel .rule-card {
  min-height: 204px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.rules-page.pk-account-panel .verify-panel {
  border-color: rgba(255, 132, 31, 0.18) !important;
}

@media screen and (max-width: 980px) {
  .rules-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .rules-page.pk-account-panel .rules-hero,
  .rules-page.pk-account-panel .rules-grid,
  .rules-page.pk-account-panel .verify-panel {
    width: 100% !important;
  }

  .rules-page.pk-account-panel .rules-grid,
  .rules-page.pk-account-panel .verify-panel {
    grid-template-columns: 1fr !important;
  }
}
</style>
